export const T = {
  en_GB: {
    back: "Back to all dynamic portfolios",
    heading: (score: string) => `Dynamic portfolio for risk score ${score}`,
  },
  nb_NO: {
    back: "Tilbake til alle dynamiske porteføljer",
    heading: (score: string) => `Dynamisk portefølje for risikoscore ${score}`,
  },
} as const;
